import { CSSProperties } from "react";
import clsx from "clsx";

import styles from "./preview-label.module.scss";

export interface IPreviewLabelProps {
  style?: CSSProperties;
  className?: string;
}

export const PreviewLabel = ({ style, className }: IPreviewLabelProps) => (
  <span style={style} className={clsx(styles.preview_label, className)}>
    PREVIEW
  </span>
);
